/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Docs_SourceInputs */

const en_public_docs_source = /** @type {(inputs: Public_Docs_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source`)
};

const es_public_docs_source = /** @type {(inputs: Public_Docs_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuente`)
};

/**
* | output |
* | --- |
* | "Source" |
*
* @param {Public_Docs_SourceInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const public_docs_source = /** @type {((inputs?: Public_Docs_SourceInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Docs_SourceInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_public_docs_source(inputs)
	return en_public_docs_source(inputs)
});